import { render, staticRenderFns } from "./CaseTable.vue?vue&type=template&id=af33fdc6&scoped=true"
import script from "./CaseTable.vue?vue&type=script&lang=js"
export * from "./CaseTable.vue?vue&type=script&lang=js"
import style0 from "./CaseTable.vue?vue&type=style&index=0&id=af33fdc6&prod&scoped=true&lang=css"
import style1 from "./CaseTable.vue?vue&type=style&index=1&id=af33fdc6&prod&scoped=true&lang=css"
import style2 from "./CaseTable.vue?vue&type=style&index=2&id=af33fdc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af33fdc6",
  null
  
)

export default component.exports